import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a69160a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "detail-container",
  ref: "scrollContainer"
}
const _hoisted_2 = { class: "survey-list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "신청가능시간", -1 /* HOISTED */))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-space" }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "btns-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" 신청가능시간 "),
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", {
          class: "row-wrapper",
          role: "listitem",
          tabindex: "0",
          "aria-label": "신청가능시간: {{ surveyUseDuration }}",
          onKeydown: [
            _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
            _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
          ]
        }, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, _toDisplayString($setup.surveyUseDuration), 1 /* TEXT */)
        ], 32 /* NEED_HYDRATION */),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.lineDemandSurveyAnswer.answerProps ?? [], (answer) => {
          return (_openBlock(), _createElementBlock("li", {
            key: answer.no,
            class: _normalizeClass(["row-wrapper", {
            empty: answer.type === 'text' && !answer.inputValue?.length,
          }]),
            role: "listitem",
            tabindex: "0",
            "aria-label": `${answer.label}: ${
            answer.inputValue ?? answer.selectValue
          }`,
            onKeydown: [
              _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
              _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
            ]
          }, [
            (answer.type !== 'text')
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(answer.label), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("p", {
              class: _normalizeClass(["content", [answer.type]])
            }, _toDisplayString(answer.inputValue ?? answer.selectValue), 3 /* TEXT, CLASS */)
          ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_5))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode($setup["BaseButton"], {
          title: "수정하기",
          "aria-label": "수정하기",
          onOnClick: $setup.emitOnClickEditBtn
        }),
        _createElementVNode("button", {
          class: "cancel-btn",
          type: "button",
          "aria-label": "신청 취소",
          onClick: $setup.emitOnClickDeleteBtn
        }, " 신청 취소 ")
      ])
    ], 512 /* NEED_PATCH */),
    ($setup.scrollContainer)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 0,
          container: $setup.scrollContainer,
          style: { bottom: '130px' }
        }, null, 8 /* PROPS */, ["container"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}